import AppCover from "./AppCover";
import AppIcon, { APP_COLORS, appKey } from "./AppIcon";

/*
  Figma "App header · აპის თავსართი": the app's cover, its icon, a caps eyebrow in the
  soft shade, a Large Title and a line under it. Row on Desktop; on Phone the icon sits
  above the text, over a scrim that keeps it readable on the art. `app` is the Figma name
  (creator-rewards, courses, cloud, consulting, gateway, live, chat, shop) or a catalog
  id; `end` sits on the far side, like Cloud's action button.
*/
const PHONE_SCRIM = "linear-gradient(180deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.15) 75%, rgba(0,0,0,0) 100%)";

const AppHeader = ({ app, eyebrow, title, subtitle, action = null, end = null, className = "" }) => {
  const colors = APP_COLORS[appKey(app)];
  return (
    <header
      className={`relative isolate flex flex-col gap-space-12 overflow-hidden rounded-radius-lg px-space-20 py-space-24 min-[700px]:flex-row min-[700px]:items-center min-[700px]:gap-space-32 min-[700px]:rounded-radius-xl min-[700px]:p-space-40 ${colors.deep} ${className}`}
    >
      <AppCover app={app} size="headerPhone" className="-z-10 min-[700px]:hidden" />
      <AppCover app={app} size="header" className="-z-10 hidden min-[700px]:block" />
      <span
        className="absolute inset-0 -z-10 hidden [[data-theme=dark]_&]:block min-[700px]:!hidden"
        style={{ backgroundImage: PHONE_SCRIM }}
        aria-hidden="true"
      />
      <AppIcon app={app} size={44} className="min-[700px]:hidden" />
      <AppIcon app={app} size={64} className="hidden min-[700px]:flex" />
      <div className="flex min-w-0 flex-1 flex-col gap-[6px]">
        {eyebrow && <p className={`text-caps-label uppercase ${colors.label}`}>{eyebrow}</p>}
        <h1 className="text-large-title text-label-primary">{title}</h1>
        {subtitle && <p className="text-subheadline text-label-secondary">{subtitle}</p>}
        {action && <div className="mt-space-8 flex flex-wrap items-center gap-space-8">{action}</div>}
      </div>
      {end && <div className="flex flex-wrap items-center gap-space-8 min-[700px]:shrink-0 min-[700px]:justify-end">{end}</div>}
    </header>
  );
};

export default AppHeader;
